import { useEffect, useRef } from "react";
import {
  onHubReconcile,
  subscribeWorkspaceConversationChanges,
  type ConversationChangeHandler,
} from "@/lib/workspace-conversation-realtime-hub";

export function useWorkspaceConversationRealtime(
  workspaceId: string | null,
  onChange: ConversationChangeHandler,
  enabled = true,
  onReconcile?: () => void,
) {
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  const onReconcileRef = useRef(onReconcile);
  onReconcileRef.current = onReconcile;

  useEffect(() => {
    if (!enabled || !workspaceId) return;
    return subscribeWorkspaceConversationChanges(workspaceId, (payload) => {
      onChangeRef.current(payload);
    });
  }, [workspaceId, enabled]);

  useEffect(() => {
    if (!enabled || !onReconcile) return;
    return onHubReconcile(() => {
      onReconcileRef.current?.();
    });
  }, [enabled, onReconcile]);
}
